import classNames from 'classnames'
import { Box, Select, SelectExtendedProps, Text } from 'grommet'
import { Controller, useFormContext } from 'react-hook-form'

interface SelectInputProps extends Omit<SelectExtendedProps, 'label'> {
  options: any[]
  label?: string
  errorMessage?: string
  name: string
  className?: string
}

export const SelectInputField = ({
  options,
  label,
  errorMessage,
  defaultValue,
  name = 'name',
  className,
  ...rest
}: SelectInputProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()
  const errorText = errors[name]?.message
  const displayError = errorText && typeof errorText === 'string' ? errorText : errorMessage
  return (
    <div className={classNames('flex-col flex', className)}>
      {label && (
        <Text margin={{ bottom: '2px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
          {label}
        </Text>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange } }) => (
          <Select
            className="borderless"
            defaultValue={defaultValue}
            height="inherit"
            onChange={selectedVal => onChange(selectedVal?.value)}
            options={options}
            value={value}
            width="100%"
            {...rest}
          />
        )}
      />

      {displayError && (
        <Box pad={{ left: 'small' }}>
          <Text color="status-error" size="small">
            {displayError}
          </Text>
        </Box>
      )}
    </div>
  )
}
